<template>
	<div class="journal-filter">
		<v-layout row align-center>
			<v-flex xs9>
			<v-layout wrap align-center justify-space-around>
				<v-flex xs3 pr-2>
					<span class="fs-10">Buscar cuenta contable</span>
					<input-searcher
						:height="30"
						:disabled="false"
						:value="model.accountingAccount.name"
						@input="$emit('on-input', $event)"
						@open-searcher="$emit('open-searcher')"
					/>
				</v-flex>
				<v-flex xs1 pl-1 pt-4>
					<span class="fs-10">Cod. Cta C</span>
					<BaseInput
						v-model="model.accountingAccount.code"
					/>
				</v-flex>
				<v-flex xs3 ml-2>
					<span class="fs-10">Estado</span>
					<BaseSelect
						solo
						:height="33"
						item-text="name"
						item-value="id"
						:items="states"
						label="Estado"
						return-object
						:value="status"
						@input="setId($event, 'status')"
					/>
				</v-flex>
				<v-flex xs2 class="date-init" ml-2>
					<span class="fs-10">Fecha Inicio</span>
					<BaseDate
						label="Fecha Inicio"
						:height="38"
					/>
				</v-flex>
				<v-flex xs2>
					<span class="fs-10">Fecha Fin</span>
					<BaseDate
						label="Fecha Inicio"
						:height="38"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs2>
			<v-layout row align-center justify-space-around>
				<v-flex xs2 pt-4 ml-2>
					<v-btn
						color="blue"
						class="ma-0 btn-action"
						@click="$emit('search')">
						Buscar
					</v-btn>
				</v-flex>	
					<v-flex xs2 pt-4 ml-5>
					<v-btn
						color="pink"
						class="ma-0 btn-action"
						@click="$emit('clean')"
					>
						Limpiar
					</v-btn>
				</v-flex>
			</v-layout>
		</v-flex>
		</v-layout>
		<slot></slot>
	</div>
</template>

<script>
	import BaseDate from '@/components/shared/inputs/base-date';
	import BaseInput from '@/components/shared/inputs/base-input';
	import inputSearcher from '@/components/shared/searcher/input-searcher';

	function search(value) {
		if (value) {
			const validName = this.subsidiaryName ?
				value.trim().toLowerCase() !== this.subsidiaryName.trim().toLowerCase() :
				!this.subsidiaryName;
			if (validName) {
				this.$emit('search-subsidiary', value);
			}
		}
	}

	function setId({ documentNumber, id, name }, modelName) {
		const model = modelName === 'subsidiaryId' ? 'subsidiaryName' : 'statusName';
		this[model] = name;
		this.$emit('set-id', { documentNumber, id }, modelName);
	}

	function openSearch() {
		this.$emit('open-search');
	}

	function data() {
		return {
			search: null,
			statusName: null,
			subsidiaryName: null,
		};
	}

	export default {
		name: 'journal-filter',
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			BaseInput,
			BaseDate,
			inputSearcher,
		},
		data,
		methods: {
			openSearch,
			setId,
		},
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
			isLoading: {
				default: false,
				type: Boolean,
			},
			states: {
				default: () => [],
				type: Array,
			},
			status: [Number, String],
			codeAccountant: [String],
			subsidiaryId: [Number],
			model: {
				type: Object,
				default: () => {},
			},
		},
		watch: {
			search,
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/journal/journal-filter.vue